"use client";

// packages/eden-list/src/components/Item.jsx
import styled from "styled-components";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { jsx } from "react/jsx-runtime";
var Li = styled.li`
  &:not(:last-child) {
    margin-block-end: ${spacing8};
  }
`;
var Item = ({ children, ...props }) => /* @__PURE__ */ jsx(Li, { ...props, children });
Item.displayName = "Item";
var Item_default = Item;
export {
  Item_default as default
};
